import { Col, Container, Row } from 'react-bootstrap';

import CardHeroBody from './CardHeroBody';
import CardHeroCta from './CardHeroCta';
import CardHeroFooter from './CardHeroFooter';
import CardHeroHeader from './CardHeroHeader';
import CardHeroPostCount from './CardHeroPostCount';
import CardHeroSender from './CardHeroSender';
import { cardHeroClassName, innerClassName } from './styles';

interface Props {
  isCardDelivered?: boolean;
  recipientName: string;
  senderName?: string | null;
  title: string;
  numPosts: number;
}

const CardHero = ({
  isCardDelivered,
  recipientName,
  senderName,
  title,
  numPosts,
}: Props) => {
  return (
    <div className={cardHeroClassName}>
      <Container className="container-flex">
        <div className={innerClassName}>
          <Row className="align-items-center">
            <Col md={9} lg={10}>
              <CardHeroHeader recipient={`${recipientName},`} title={title} />
            </Col>
            <Col md={3} lg={2}>
              <CardHeroBody>
                {isCardDelivered ? (
                  senderName ? (
                    <CardHeroSender sender={senderName} />
                  ) : null
                ) : (
                  <CardHeroCta />
                )}
              </CardHeroBody>
            </Col>
          </Row>
          {!isCardDelivered && senderName && (
            <CardHeroFooter>
              <CardHeroPostCount numPosts={numPosts} />
              <CardHeroSender sender={senderName} fontSmall />
            </CardHeroFooter>
          )}
        </div>
      </Container>
    </div>
  );
};

CardHero.displayName = 'CardHero';

export default CardHero;
